import React from 'react'

import { EuiTitle, EuiSpacer, EuiFlexItem, EuiFlexGroup } from '@elastic/eui'

import { MasterCampaignPlanCampaignBuilder } from 'api/entities/MasterCampaignStub'

import GanttChart from '../../GanttChart/GanttChart'
import BackgroundContentCard from '../BackgroundContentCard'

export interface CampaignTimelineProps {
  campaigns: MasterCampaignPlanCampaignBuilder[]
  planStartDate: moment.Moment
  planDurationMonths: number
  isHoverable?: boolean
  isClickable?: boolean
}

const CampaignTimeline: React.FC<CampaignTimelineProps> = ({ campaigns, planStartDate, planDurationMonths, isHoverable, isClickable }) => {
  return (
    <BackgroundContentCard>
      <EuiFlexGroup>
        <EuiFlexItem />
        <EuiFlexItem style={{ textAlign: 'center' }}>
          <EuiTitle size='s'>
            <h4>Campaign Timeline</h4>
          </EuiTitle>
        </EuiFlexItem>
        <EuiFlexItem />
      </EuiFlexGroup>

      <EuiSpacer size='m' />

      <GanttChart campaigns={campaigns} planStartDate={planStartDate} planDurationMonths={planDurationMonths} isHoverable={isHoverable} isClickable={isClickable} />
    </BackgroundContentCard>
  )
}

export default CampaignTimeline
